import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash"
import { loadingStatus, getPayload } from "actions"
import moment from "moment"
import Title from "../general/title"
import numeral from "numeral"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import submitData from "helpers/asyncSubmitData"
import settings from 'settings'

const Takedown = (props) => {
	const payload = useSelector((state) => state.payload)
	const payloadStatus = useSelector((state) => state.payloadStatus)
	const activeProperties = useSelector((state) => state.activeProperties)
	const [data, setData] = useState([])
	const dispatch = useDispatch()
	const [columns, setColumns] = useState([
		{
			Header: "Builder",
			accessor: "builder",
			display: true,
			name: "Builder",
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Lot Type",
			accessor: "lot_type",
			display: true,
			name: "Lot Type",
			filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
		},
		{
			Header: "Subdivision",
			accessor: "subdivision",
			display: true,
			name: "Subdivision",
			filterMethod: (f, r) => helpers.tableText(f, r, "subdivision"),
		},
		{
			accessor: "section",
			display: true,
			className: "center",
			name: "Section",
			Header: () => (
				<div
					style={{
						textAlign: "center",
					}}>
					Section
				</div>
			),
			filterMethod: (f, r) => helpers.tableText(f, r, "section"),
		},
		{
			accessor: "block",
			display: true,
			className: "center",
			name: "Block",
			Header: () => (
				<div
					style={{
						textAlign: "center",
					}}>
					Block
				</div>
			),
		},
		{
			accessor: "lot",
			display: true,
			className: "center",
			name: "Lot",
			Header: () => (
				<div
					style={{
						textAlign: "center",
					}}>
					Lot
				</div>
			),
		},
		{
			Header: "Takedown Date",
			accessor: "takedown_date",
			name: "Takedown Date",
			display: true,
			Cell: (v) => {
				if (v.value) return moment.unix(v.value).format("M/DD/YY")
				return ""
			},
			filterMethod: (f, r) => helpers.dateFilter(f, r),
		},
		{
			Header: () => (
				<div
					style={{
						textAlign: "right",
					}}>
					Takedown Price
				</div>
			),
			accessor: "takedown_price",
			name: "Takedown Price",
			display: true,
			className: "right",
			Cell: (v) => {
				if (v.value) {
					return numeral(v.value).format("$0,0.00")
				}
				return "$0.00"
			},
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					if (v["takedown_price"]) {
						total += parseFloat(v["takedown_price"])
					}
				})
				if (typeof total == "number") {
					return numeral(total).format("$0,0.00")
				}
				return total
			},
		},
		{
			Header: () => (
				<div
					style={{
						textAlign: "right",
					}}>
					Base Lot Price
				</div>
			),
			accessor: "base_price",
			display: true,
			className: "right",
			name: "Base Price",
			Cell: (v) => {
				if (v.value) {
					return numeral(v.value).format("$0,0.00")
				}
				return "$0.00"
			},
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					if (v["base_price"]) {
						total += parseFloat(v["base_price"])
					}
				})
				if (typeof total == "number") {
					return numeral(total).format("$0,0.00")
				}
				return total
			},
		},
		{
			Header: () => (
				<div
					style={{
						textAlign: "right",
					}}>
					Premium
				</div>
			),
			accessor: "premium",
			display: true,
			className: "right",
			name: "Premium",
			Cell: (v) => {
				if (v.value) {
					return numeral(v.value).format("$0,0.00")
				}
				return "$0.00"
			},
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					if (v["premium"]) {
						total += parseFloat(v["premium"])
					}
				})
				if (typeof total == "number") {
					return numeral(total).format("$0,0.00")
				}
				return total
			},
		},
		{
			Header: () => (
				<div
					style={{
						textAlign: "right",
					}}>
					Escalation
				</div>
			),
			accessor: "escalation",
			display: true,
			className: "right",
			name: "Escalation",
			Cell: (v) => {
				if (v.value) {
					return numeral(v.value).format("$0,0.00")
				}
				return "$0.00"
			},
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					if (v["escalation"]) {
						total += parseFloat(v["escalation"])
					}
				})
				if (typeof total == "number") {
					return numeral(total).format("$0,0.00")
				}
				return total
			},
		},
		{
			Header: () => (
				<div
					style={{
						textAlign: "right",
					}}>
					Fence Fee
				</div>
			),
			accessor: "fence",
			display: true,
			className: "right",
			name: "Fence Fee",
			Cell: (v) => {
				if (v.value) {
					let val = v.value
					val = parseFloat(val)
					return `$${val.toLocaleString(undefined, { minimumFractionDigits: 2 })}`
				}
				return "$0.00"
			},
			Footer: (props) => {
				let total = 0
				_.forEach(props.data, (v) => {
					if (v["fence"]) {
						total += parseFloat(v["fence"])
					}
				})
				if (typeof total == "number") {
					return numeral(total).format("$0,0.00")
				}
				return total
			},
		},
		{
			Header: "Address",
			accessor: "address",
			name: "Address",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "address"),
		},
	])

	const [detailedColumns, setDetailedColumns] = useState([
		{
			Header: "Lot Type",
			accessor: "lot_type",
			filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
		},
		{
			Header: "Lot",
			accessor: "lot",
			filterMethod: (f, r) => helpers.tableText(f, r, "lot"),
		},
		{
			Header: "Block",
			accessor: "block",
			filterMethod: (f, r) => helpers.tableText(f, r, "block"),
		},
		{
			Header: "Section",
			accessor: "section",
			filterMethod: (f, r) => helpers.tableText(f, r, "section"),
		},
		{
			Header: "Builder",
			accessor: "builder",
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Address",
			accessor: "address",
			filterMethod: (f, r) => helpers.tableText(f, r, "address"),
		},
		{
			Header: "",
			className: "ReactTable__gutter",
			headerClassName: "ReactTable__headerGutter",
			maxWidth: 10,
			sortable: false,
			filterable: false,
			gutter: true,
		},
		{
			Header: "Lot Sale",
			columns: [
				{
					Header: "Base Price",
					accessor: "base_price",
					filterMethod: (f, r) => helpers.tableText(f, r, "base_price"),
					Cell: (v) => numeral(v.value).format("$0,0.00"),
				},
				{
					Header: "Premium",
					accessor: "premium",
					filterMethod: (f, r) => helpers.tableText(f, r, "premium"),
					Cell: (v) => numeral(v.value).format("$0,0.00"),
				},
				{
					Header: "Escalation",
					accessor: "escalation",
					filterMethod: (f, r) => helpers.tableText(f, r, "escalation"),
					Cell: (v) => numeral(v.value).format("$0,0.00"),
				},
				{
					Header: "Fence Fee",
					accessor: "fence_fee",
					filterMethod: (f, r) => helpers.tableText(f, r, "fence_fee"),
					Cell: (v) => numeral(v.value).format("$0,0.00"),
				},
				{
					Header: "Marketing",
					accessor: "fee_marketing",
					filterMethod: (f, r) => helpers.tableText(f, r, "fee_marketing"),
					Cell: (v) => numeral(v.value).format("$0,0.00"),
				},
				{
					Header: "Takedown Price",
					accessor: "takedown_price",
					filterMethod: (f, r) => helpers.tableText(f, r, "takedown_price"),
					Cell: (v) => numeral(v.value).format("$0,0.00"),
				},
				{
					Header: "Takedown Date",
					accessor: "takedown_date",
					filterMethod: (f, r) => helpers.tableText(f, r, "takedown_date"),
					Cell: (v) => helpers.tableDate(v),
				},
			],
		},
		{
			Header: "",
			className: "ReactTable__gutter",
			headerClassName: "ReactTable__headerGutter",
			maxWidth: 10,
			sortable: false,
			filterable: false,
			gutter: true,
		},
		{
			Header: "Home Sale",
			columns: [
				{
					Header: "Build Status",
					accessor: "build_status",
					filterMethod: (f, r) => helpers.tableText(f, r, "build_status"),
				},
				{
					Header: "Sale Status",
					accessor: "sale_status",
					filterMethod: (f, r) => helpers.tableText(f, r, "sale_status"),
				},
				{
					Header: "Sale Date",
					accessor: "sale_date",
					filterMethod: (f, r) => helpers.tableText(f, r, "sale_date"),
					Cell: (v) => helpers.tableDate(v),
				},
				{
					Header: "Closing Date",
					accessor: "closing_date",
					filterMethod: (f, r) => helpers.tableText(f, r, "closing_date"),
					Cell: (v) => helpers.tableDate(v),
				},
				{
					Header: "Sale Price",
					accessor: "sale_price",
					filterMethod: (f, r) => helpers.tableText(f, r, "sale_price"),
					Cell: (v) => (v.value ? numeral(v.value).format("$0,0") : null),
				},
			],
		},
		{
			Header: "",
			className: "ReactTable__gutter",
			headerClassName: "ReactTable__headerGutter",
			maxWidth: 10,
			sortable: false,
			filterable: false,
			gutter: true,
		},
		{
			Header: "Primary Last",
			accessor: "primary_last",
			filterMethod: (f, r) => helpers.tableText(f, r, "primary_last"),
		},
		{
			Header: "HUD Closing Date",
			accessor: "hud_closing_date",
			filterMethod: (f, r) => helpers.tableText(f, r, "hud_closing_date"),
			Cell: (v) => helpers.tableDate(v),
		},
	])

	const [schedule, setSchedule] = useState([
		{
			Header: "Contract ID",
			accessor: "id",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "id"),
		},
		{
			Header: "Sections",
			accessor: "section",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "section"),
		},
		{
			Header: "Builders",
			accessor: "builder",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Lot Types",
			accessor: "lot_type",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
		},
		{
			Header: "# of Lots",
			accessor: "num_lots",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "num_lots"),
		},
		{
			Header: "Should Be Taken",
			accessor: "should_be_taken",
			display: true,
		},
		{
			Header: "Taken Down",
			accessor: "takedowns",
			display: true,
		},
		{
			Header: "Remaining",
			accessor: "remaining",
			display: true,
		},
		{
			Header: "Upcoming",
			accessor: "upcoming",
			display: true,
		},
		{
			Header: "Status",
			accessor: "status",
			display: true,
		},
		{
			Header: "Completed Construction",
			accessor: "completed",
			display: true,
		},
		{
			Header: "Started Construction",
			accessor: "started",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "started"),
		},
		{
			Header: "Buyer Sold",
			accessor: "buyer_sold",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "buyer_sold"),
		},
	])

	const [scheduleDetail, setScheduleDetail] = useState([
		{
			Header: "Contract ID",
			accessor: "id",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "id"),
		},
		{
			Header: "Sections",
			accessor: "section",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "section"),
		},
		{
			Header: "Builders",
			accessor: "builder",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
		},
		{
			Header: "Lot Types",
			accessor: "lot_type",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
		},
		{
			Header: "Date",
			accessor: "date",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "date"),
			Cell: (v) => helpers.tableDate(v),
		},
		{
			Header: "# of Contracted Lots",
			accessor: "num_lots",
			display: true,
			filterMethod: (f, r) => helpers.tableText(f, r, "num_lots"),
		},
		{
			Header: "Should Be Taken",
			accessor: "should_be_taken",
			display: true,
		},
		{
			Header: "Actual Taken",
			accessor: "actual_taken",
			display: true,
		},
		{
			Header: "Status",
			accessor: "status",
			display: true,
			filterMethod: (f, r) => {
				try {
					let val = r._original.statusText
					if (val && typeof val === "string") {
						val = val.toLowerCase()
						if (val.includes(f?.value?.toLowerCase())) return true
					}
				} catch (e) {
					console.log(e)
				}
			},
		},
	])

	const pullData = async () => {
		if (!activeProperties[0]) return
		dispatch(loadingStatus(true))
		let resp = await submitData("mainRetrieve", {
			property: activeProperties[0],
			action: "getLotContracts",
		})
		if (resp.status === 200) {
			setData(resp.data)
		}
		dispatch(loadingStatus(false))
	}

	useEffect(() => {
		pullData()
	}, [props.activeProperties])

	const [sorted, setSorted] = useState([])
	const [filtered, setFiltered] = useState([])
	const [showFilters, setShowFilters] = useState(false)

	const currentDates = useSelector((state) => state.currentDates)

	const supply = () => {
		let ret = []
		_.forEach(payload.exec.lots, (r) => {
			if (!r.builder || !r.takedown_date) {
				return
			}
			if (r.takedown_date < currentDates.startStamp || r.takedown_date > currentDates.endStamp) {
				return
			}
			let section = _.find(payload.public.sections, { id: r.section_id })
			if (!section) {
				console.log("no section")
				return
			}
			let subdivision = _.find(payload.public.subdivisions, { id: r.subdivision })
			let builder = _.find(payload.public.builders, { id: r.builder })
			if (!builder) {
				console.log("no builder")
				return
			}
			if (!r.takedown_price) {
				r.takedown_price = 0
			}
			if (!r.base_price) {
				r.base_price = 0
			}
			if (!r.premium) {
				r.premium = 0
			}
			let escalation = r.takedown_price - r.base_price - parseFloat(r.premium)
			if(r.fee_escalation) {
				escalation = r.fee_escalation
			}
			let type = _.find(payload.public.lot_types, { id: r.lot_type })
			let takedownPrice = numeral(r.takedown_price).value() || 0
			ret.push({
				subdivision: subdivision ? subdivision.name : "",
				builder: builder.name,
				section: r.section_name,
				block: r.block,
				lot: r.lot,
				lot_type: type ? type.name : "",
				takedown_date: r.takedown_date,
				takedown_price: takedownPrice,
				base_price: r.base_price ? r.base_price.toFixed(2) : 0,
				premium: r.premium ? parseFloat(r.premium) : "0.00",
				escalation: escalation,
				fence: r.fence_fee ? r.fence_fee.toFixed(2) : "0.00",
				address: r.address,
			})
		})

		return ret
	}

	const detailedSupply = () => {
		let ret = []
		_.forEach(payload.exec.lots, (r) => {
			if (!r.builder || !r.takedown_date) {
				//if (!r.builder) console.log(r)
				return
			}
			let section = _.find(payload.public.sections, { id: r.section_id })
			if (!section) {
				console.log("no section")
				return
			}
			let builder = _.find(payload.public.builders, { id: r.builder })
			if (!builder) {
				console.log("no builder")
				return
			}
			if (!r.takedown_price) {
				r.takedown_price = 0
			}
			if (!r.base_price) {
				r.base_price = 0
			}
			if (!r.premium) {
				r.premium = 0
			}
			let escalation = _.round(r.takedown_price - r.base_price - parseFloat(r.premium), 2)
			let type = _.find(payload.public.lot_types, { id: r.lot_type })
			ret.push({
				builder: builder.name,
				section: r.section_name,
				block: r.block,
				lot: r.lot,
				lot_type: type ? type.name : "",
				takedown_date: r.takedown_date,
				takedown_price: numeral(r.takedown_price).value() || 0,
				base_price: r.base_price ? _.round(r.base_price, 2) : 0,
				premium: r.premium ? _.round(r.premium, 2) : null,
				fee_marketing: r.fee_marketing ? _.round(r.fee_marketing, 2) : null,
				escalation,
				fence_fee: r.fence_fee ? _.round(r.fence_fee) : null,
				address: r.address,
				build_status: helpers.buildStatus(r),
				sale_status: helpers.saleStatus(r),
				sale_date: r.sale_date,
				closing_date: r.closing_date,
				sale_price: r.sale_price,
				primary_last: r.primary_last,
				hud_closing_date: r.date_hud_closing,
			})
		})
		return ret
	}

	const scheduleSupply = () => {
		let ret = []
		_.forEach(data, (v) => {
			let builder = _.find(payload.public.builders, { id: v.builder })
			let sections = ""
			_.forEach(v.section_id, (sec) => {
				let section = _.find(payload.public.sections, { id: sec })
				sections += section.name + ", "
			})
			sections = _.trimEnd(sections, ", ")
			let lotTypes = ""
			_.forEach(v.lot_type, (lt) => {
				let type = _.find(payload.public.lot_types, { id: lt })
				lotTypes += type.name + ", "
			})
			lotTypes = _.trimEnd(lotTypes, ", ")
			let lots = []
			let takedowns = 0
			let completed = 0
			let started = 0
			let num_lots = 0
			let buyer_sold = 0
			let now = moment().unix()
			let should_be_taken = 0
			_.forEach(v.schedule, (s) => {
				if (s.date <= now) should_be_taken += s.num
			})
			_.forEach(payload.exec.lots, (l) => {
				if (l.lot_contract !== v.id) return
				num_lots++
				if (!l.takedown_date) return
				takedowns++
				lots.push(l)
				if (l.complete_date) completed++
				if (l.start_date) started++
				if (l.sale_id) buyer_sold++
			})
			let status = ""
			if (should_be_taken > takedowns) status = "Behind"
			else if (should_be_taken === takedowns) status = "On Schedule"
			else status = "Ahead"
			let f = {
				id: v.id,
				builder: builder?.name || "",
				lot_type: lotTypes,
				section: sections,
				num_lots,
				takedowns: takedowns,
				should_be_taken,
				remaining: num_lots - takedowns,
				upcoming: num_lots - should_be_taken,
				status,
				completed,
				started,
				buyer_sold,
			}
			ret.push(f)
		})
		return ret
	}

	const scheduleDetailSupply = () => {
		let ret = []
		_.forEach(data, (v) => {
			let builder = _.find(payload.public.builders, { id: v.builder })
			let sections = ""
			_.forEach(v.section_id, (sec) => {
				let section = _.find(payload.public.sections, { id: sec })
				sections += section.name + ", "
			})
			sections = _.trimEnd(sections, ", ")
			let lotTypes = ""
			_.forEach(v.lot_type, (lt) => {
				let type = _.find(payload.public.lot_types, { id: lt })
				lotTypes += type.name + ", "
			})
			lotTypes = _.trimEnd(lotTypes, ", ")
			let should_be_taken = 0
			let takedowns = 0
			let accountedFor = []
			_.forEach(v.schedule, (s) => {
				should_be_taken += s.num
				_.forEach(payload.exec.lots, (l) => {
					if (l.lot_contract !== v.id) return // lot not on this contract
					if (l.takedown_date && l.takedown_date <= s.date && !accountedFor.includes(l.id)) {
						accountedFor.push(l.id)
						takedowns++
					}
				})
				let status = ""
				let statusText = ""
				if (should_be_taken > takedowns) {
					statusText = `Behind ${should_be_taken - takedowns}`
					status = <span className="bg-red-500 font-bold text-white px-2 py-1">{statusText}</span>
				} else if (should_be_taken === takedowns) {
					statusText = `On Schedule`
					status = <span className="bg-black font-bold text-white px-2 py-1">{statusText}</span>
				} else {
					statusText = `Ahead ${takedowns - should_be_taken}`
					status = <span className="bg-green-500 font-bold text-white px-2 py-1">{statusText}</span>
				}
				let f = {
					id: v.id,
					date: s.date,
					builder: builder?.name || "",
					lot_type: lotTypes,
					section: sections,
					num_lots: s.num,
					actual_taken: takedowns,
					should_be_taken,
					status,
					statusText,
				}
				ret.push(f)
			})
		})
		return ret
	}

	if (payloadStatus) {
		return (
			<div className="inventory">
				<div className="imageGroup">
					<Title title="Takedown Report" />
					<div className="content">
						<FullTable
							data={supply()}
							columns={columns}
							name="takedown"
							title="Takedown Report"
							classNames="small"
							pageSize={40}
						/>
					</div>
				</div>
				<div className="imageGroup">
					<div className="content">
						<h2>Detailed Takedown Report</h2>
						<p className="mid infoNote py-2 m-0">
							<i className={`fas fa-info-circle`} />
							The following table does not take the date range into consideration and is considered an up
							to the minute analysis.
						</p>
						<FullTable
							data={detailedSupply()}
							columns={detailedColumns}
							hasColumnsGrouped={true}
							name="takedown__detailed"
							title="Detailed Takedown Report"
							classNames="small"
							pageSize={30}
						/>
					</div>
				</div>
				<div className="imageGroup">
					<div className="content">
						<h2>Schedule Overview</h2>
						<FullTable
							data={scheduleSupply()}
							columns={schedule}
							hasColumnsGrouped={true}
							name="takedown__scheduleOverview"
							title="Schedule Overview"
							classNames="small"
							pageSize={10}
						/>
						<h2>Schedule Detail</h2>
						<FullTable
							data={scheduleDetailSupply()}
							columns={scheduleDetail}
							hasColumnsGrouped={true}
							name="takedown__scheduleDetailed"
							title="Schedule Detailed"
							classNames="small"
							pageSize={10}
						/>
					</div>
				</div>
			</div>
		)
	} else {
		return ""
	}
}

export default Takedown
